module.exports = __webpack_public_path__ + "img/VALOR_INTEGRIDAD1.2fba49f3.png";